import '../styles/globals.css'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { ToastContextProvider } from "@byma/shared/contexts/ToastContext";
import { ImWhatsapp } from 'react-icons/im'
dayjs.locale('pt-br')

function WhatsappButton() {
    return (
        <a
            href="https://wa.me/5519971372496"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fale conosco no WhatsApp"
            className="fixed bottom-4 right-4 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform"
        >
            <ImWhatsapp size={26} />
        </a>
    )
}

function MyApp({ Component, pageProps }) {
  return (
      <ToastContextProvider>
          <Component {...pageProps} />
          <WhatsappButton />
      </ToastContextProvider>
  )
}

export default MyApp
